window.UI = window.UI || {};

window.UI.IncrementViewCount = (function () {
    'use strict';

    const IncrementViewCount = function (url, addOnUuid, timeOut) {
        this.url = url;
        this.addOnUuid = addOnUuid;
        this.timeOut = timeOut || 5000;
    };

    IncrementViewCount.prototype.execute = function () {
        if (this._isBotRequest()) { return; }

        setTimeout(this._updateViewCount.bind(this), this.timeOut);
    };

    IncrementViewCount.prototype._updateViewCount = function () {
        const csrfToken = document.querySelector('meta[name="csrf-token"]');

        if (!csrfToken) { return; }

        // PUT requests are currently (Mar 13 2019) dropped by the load balancer,
        // so we use the "_method" parameter to tell Rails to treat the POST as if it were a PUT
        const formData = new URLSearchParams();
        formData.append('uuid', this.addOnUuid);
        formData.append('_method', 'PUT');

        fetch(this.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-CSRF-Token': csrfToken.getAttribute('content')
            },
            credentials: 'same-origin',
            body: formData
        }).catch(() => {}); // Silent failure
    };

    IncrementViewCount.prototype._isBotRequest = function () {
        if (window && window.navigator) {
            return (window.navigator.userAgent.match(/bot|spider|crawl|curl|slurp/i) !== null);
        }
    };

    return IncrementViewCount;
}());
